"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimsFactory = void 0;
const did_ethr_resolver_1 = require("@ew-did-registry/did-ethr-resolver");
const claimsUser_1 = require("../claimsUser");
const claimsIssuer_1 = require("../claimsIssuer");
const claimsVerifier_1 = require("../claimsVerifier");
/**
 * An implementation of claims factory
 * @class
 */
class ClaimsFactory {
    // eslint-disable-next-line no-useless-constructor
    constructor(keys, document, store, providerSettings) {
        this.keys = keys;
        this.document = document;
        this.store = store;
        this.providerSettings = providerSettings;
        this.owner = did_ethr_resolver_1.EwSigner.fromPrivateKey(keys.privateKey, providerSettings);
    }
    /**
     * Constructs instance of ClaimsUser
     *
     * @returns { IClaimsUser }
     */
    createClaimsUser() {
        return new claimsUser_1.ClaimsUser(this.owner, this.document, this.store);
    }
    /**
     * Contstructs instance of ClaimsIssuer
     *
     * @returns { IClaimsIssuer }
     */
    createClaimsIssuer() {
        return new claimsIssuer_1.ClaimsIssuer(this.owner, this.document, this.store);
    }
    /**
     * Constructs instance of ClaimsUser
     *
     * @returns { IClaimsVerifier }
     */
    createClaimsVerifier() {
        return new claimsVerifier_1.ClaimsVerifier(this.owner, this.document, this.store);
    }
}
exports.ClaimsFactory = ClaimsFactory;
//# sourceMappingURL=claimsFactory.js.map